import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import useLoadMoreData from '../useLoadMoreData';

const DefaultError = ({
  onRetry,
}: Pick<ReturnType<typeof useLoadMoreData>, 'onRetry'>) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <>
      <AlertWarningIcon size={20} style={{ marginRight: theme.spacing.XS }} />
      <span
        css={[theme.typography.bodySmall, { marginRight: theme.spacing.XS }]}
      >
        {T.translate('COULDNT_LOAD')}
      </span>
      <LinkButton
        data-testid="tryAgain"
        onClick={onRetry}
        size={LinkButton.SIZES.SMALL}
      >
        {T.translate('TRY_AGAIN')}
      </LinkButton>
    </>
  );
};

export default DefaultError;
